<template>
  <div class="diaglog-wrapper">
    <div class="dialog-container product-detail-dialog">
      <div class="product-detail-dialog-container">
        <p class="title">{{ letter.check_remove_cart }}</p>
        <div class="product-box">
          <div
            class="product-item j-select-product"
            :data-productid="deleteItem.PRODUCT_ID"
            :pointValue="deleteItem.PRODUCT_ID + ';' + deleteItem.CP_PRODUCT_ID"
          >
            <div class="tag-wrap">
              <span class="product-tag" v-if="extraTip(deleteItem)">
                {{ extraTip(deleteItem) }}
              </span>
              <span class="product-tag coupon" v-if="+deleteItem.COUPON">{{
                letter.couponCanUseQuan
              }}</span>
            </div>
            <div class="detail-wrap">
              <div class="left">
                <div class="text">
                  <p class="product-name name">
                    {{ getProductName(deleteItem) }}
                  </p>
                </div>
                <prop-img :item="deleteItem"></prop-img>
              </div>
              <div class="right">
                <div class="product-price">
                  {{ deleteItem.amountLevel.TRANS_AMOUNT
                  }}{{ deleteItem.amountLevel.SHOW_CURRENCY }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <button
            class="btn cancel j-click-cancel-delete-to-cart-popup"
            :pointValue="deleteItem.PRODUCT_ID + ';' + deleteItem.CP_PRODUCT_ID"
            @click="close"
          >
            {{ letter.cancel }}
          </button>
          <button
            class="btn confirm j-click-delete-to-cart-popup"
            :pointValue="deleteItem.PRODUCT_ID + ';' + deleteItem.CP_PRODUCT_ID"
            @click="subProduct(deleteItem)"
          >
            {{ letter.remove_cart }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  UPDATE_SHOW_CART_DELETE_POPUP,
  SUB_PRODUCT_OF_CART
} from '@store/officialStore/cart';
import ProductItem from '@components/officialStore/product/ProductItem.vue';
import PropImg from '@components/officialStore/product/PropImg.vue';
import cartAddAndDetail from '@mixins/officialStore/cartAddAndDetail';
import { mapState } from 'vuex';
import product from '@mixins/officialStore/product';
import productName from '@mixins/product';
export default {
  mixins: [cartAddAndDetail, product, productName],
  computed: {
    ...mapState({
      deleteItem: state => state.cart.deleteItem
    })
  },
  methods: {
    close() {
      this.$store.commit(UPDATE_SHOW_CART_DELETE_POPUP, false);
    },
    subProduct(item) {
      this.$store.commit(SUB_PRODUCT_OF_CART, item);
      window.webstorev1DataLayer.push({
        eventName: 'remove_cart',
        eventType: 'add_to_cart',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: '1',
          product_currency: item.amountLevel.CURRENCY,
          product_money: item.amountLevel.TRANS_AMOUNT
        }
      });
      this.close();
    }
  },
  components: {
    ProductItem,
    PropImg
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.product-detail-dialog {
  padding: 0;
  height: auto;
  background-size: 100% 100%;
  @psetbg ('common-popup.png', false, false);
}
.product-detail-dialog-container {
  width: 100%;
  height: 100%;
}
.title {
  margin: 50px auto 32px;
  text-align: center;
  font-weight: bolder;
  font-size: 48px;
  color: var(--global-tip-popup-title);
}
.product-box {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  padding: 0 25px;
}
.product-item {
  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px;
  background-size: 100% 100%;
  cursor: pointer;
  @psetbg ('cart-list-item-bg.png', false, false);
  .tag-wrap {
    margin-top: 7px;
    border-bottom: 2px solid var(--product-item-fenge-line);
    height: 34px;
    .product-tag {
      margin-right: 16px;
      padding: 5px 15px;
      background: var(--product-item-tag-bg);
      font-size: 16px;
      color: var(--product-item-tag-text);
      &.coupon {
        background-color: var(--product-item-tag-coupon-bg);
      }
    }
  }
  .detail-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 20px;
    margin-bottom: 10px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 445px;
      .img-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 18px;
        width: 84px;
        height: 84px;
        background: url($pnsImg + 'delete-img-bg.png') no-repeat top;
        background-size: contain;
        .product-icon {
          width: 80%;
          height: auto;
        }
      }
      .text {
        display: flex;
        margin-bottom: 50px;
        width: 100%;
        .product-name {
          line-height: 32px;
          /*!rtl:ignore*/
          direction: ltr;
          font-size: 24px;
          color: var(--product-item-name);
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 170px;
      .product-price {
        text-align: center;
        font-size: 36px;
        color: var(--product-item-price);
      }
    }
  }
}
.btn-wrap {
  display: flex;
  justify-content: space-between;
  margin: 58px auto;
  width: 85%;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    font-size: 36px;
    color: var(--global-tip-popup-btn);
    &.cancel {
      cursor: pointer;
      @psetbg ('cancel.png');
    }
    &.confirm {
      cursor: pointer;
      @psetbg ('confirm.png');
    }
  }
}
@media screen and (orientation: landscape) {
  .product-detail-dialog {
    padding: 0;
    background-size: 100% 100%;
    @psetbg ('common-popup-hen.png', false, false);
  }
  .title {
    margin: 32px auto 21px;
    font-size: 30px;
  }
  .product-box {
    padding: 0 19px;
  }
  .product-item {
    padding: 8px;
    .tag-wrap {
      margin-top: 4px;
      height: 41px;
      .product-tag {
        padding: 2px 15px;
        font-size: 20px;
      }
    }
    .detail-wrap {
      margin-top: 10px;
      .left {
        display: flex;
        width: 445px;
        .img-wrap {
          width: 54px;
          height: 54px;
          background: url($pnsImg + 'delete-img-bg-hen.png') no-repeat top;
          background-size: contain;
        }
        .text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .product-name {
            line-height: 13px;
            /*!rtl:ignore*/
            direction: ltr;
            font-size: 24px;
          }
          .look-detail {
            font-size: 14px;
            .look-ico {
              width: 11px;
              height: 10px;
              background: url($pnsImg + 'look-detail-hen.png') no-repeat top;
              background-size: cover;
            }
          }
        }
      }
      .right {
        .product-price {
          font-size: 30px;
        }
      }
    }
  }
  .btn-wrap {
    display: flex;
    justify-content: space-between;
    margin: 38px auto;
    width: 85%;
    .btn {
      display: block;
      background-size: cover;
      line-height: 53px;
      font-size: 24px;
      &.cancel {
        cursor: pointer;
        @psetbg ('cancel-hen.png');
      }
      &.confirm {
        cursor: pointer;
        @psetbg ('confirm-hen.png');
      }
    }
  }
  ::v-deep .product-detail {
    width: 388px;
  }
}
</style>
